import { Link } from "react-router-dom";

const copy = {
  liveChatPreEngagement: {
    heading: "Chat with a live agent",
    description:
      "Live chat is only available for certain Twilio products and issue areas. Please select an option below to continue.",
    supportedProducts: {
      label: "Supported product",
    },
    startLiveChatButton: "Start live chat",
    closeFormButton: "Close",
    message: {
      label: "Message",
    },
    unsupportedProductCallout: {
      heading: "We do not support other products.",
      description: (toLocation: string) => [
        "Please ",
        <Link to={toLocation}>submit a ticket</Link>,
        " so we can better help you.",
      ],
    },
  },
};

export default copy;
